'use strict';

var React = require('react/addons');
var pad = require('pad');

var Immutable = require('immutable');

var SelectOne = require('./simple-choice');

var hourChoices = Immutable.Range(0, 24).map(function(i) {
  var v = pad(2, i, '0');
  return {
    name: v,
    value: v
  };
}).toJS();

var minuteChoices = Immutable.Range(0, 60, 5).map(function(i) {
  var v = pad(2, i, '0');
  return {
    name: v,
    value: v
  };
}).toJS();


var TimeSelect = React.createClass({

   getInitialState() {
    return {
      tempMinutes: null,
      tempHour: null
    };
  },

  onHourChange(event) {
    var hour = event.target.value;
    var value = this.props.value;

    var __;
    var minutes = null;

    if (value) {
      [__, minutes, __] = value.split(':');
    } else if (this.state.tempMinutes) {
      minutes = this.state.tempMinutes;
    }

    if (hour && minutes) {
      this.props.onChange(`${ hour }:${ minutes }:00`);
      this.setState({tempMinutes: null});
    } else {
      this.setState({tempHour: hour});
    }
  },

  onMinuteChange(event) {
    var minutes = event.target.value;
    var value = this.props.value;

    var __;
    var hour = null;

    if (value) {
      [hour, __, __] = value.split(':');
    } else if (this.state.tempHour) {
      hour = this.state.tempHour;
    }

    if (hour && minutes) {
      this.props.onChange(`${ hour }:${ minutes }:00`);
      this.setState({tempHour: null});
    } else {
      this.setState({tempMinutes: minutes});
    }
  },

  render: function() {
    var {value} = this.props;
    var hour = null;
    var minutes = null;

    var __;

    if (value) {
      [hour, minutes, __] = value.split(':');
    }

    return (
      <div className="ofs-Input__Wrapper">
        <input type="hidden" {...this.props} value={value} ref="input" />
        <div className="ofs-Input__TimeInput">
          <SelectOne className="bdd-time-select-hours" onChange={this.onHourChange} placeholder="--" options={hourChoices} value={hour} />
        </div>
        <div className="ofs-Input__TimeInput">
          <SelectOne className="bdd-time-select-minutes" onChange={this.onMinuteChange} placeholder="--"  options={minuteChoices} value={minutes} />
        </div>
      </div>
    );
  }
});

module.exports = TimeSelect;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/time-select.jsx
 **/